import { TAB_MANUAL } from "/app/apps/webapp/src/app/routes/_authenticated/resources/products/new.tsx?tsr-shared=1";
const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/products/new.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/products/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
/** Default (no `tab`) is the Built-in catalog search; `?tab=manual` deep-links manual entry. */
const newProductSearchSchema = z.object({
  tab: z.literal(TAB_MANUAL).optional().catch(undefined)
});
export const Route = createFileRoute('/_authenticated/resources/products/new')({
  validateSearch: newProductSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});